export const messages_no = {
    nameEmpty: "Navn kan ikke være tomt.",
    emailEmpty: "E-postadresse kan ikke være tom.",
    emailNotValid: "E-postadressen er ikke gyldig, vennligst skriv inn en riktig e-postadresse.",
    locationEmpty: "Plassering kan ikke være tom.",
    interests: "Velg 3 interesseområder.",
    profileSaved: "Profildetaljer er lagret.",
    profilePic: "Profilbildet er lagret.",
    addToFavorites:"Vellykket lagt til din favoritt",
    removeFromFavorites:"vellykket fjernet fra favoritt",
};


// WEBPACK FOOTER //
// ./src/constants/messages_no.js